/*
 * BioIndex
 * Copyright (c) 2026 BioIndex™. All rights reserved.
 * Unauthorized copying, scraping, redistribution, or commercial reuse is prohibited.
 */

import { useEffect, useState } from "react";

import { auth } from "../firebase";

export default function useAdminClaim() {
  const [adminState, setAdminState] = useState({
    adminLoading: true,
    isAdmin: false,
  });

  useEffect(() => {
    let active = true;

    async function loadAdminClaim() {
      const user = auth.currentUser;

      if (!user) {
        if (active) {
          setAdminState({
            adminLoading: false,
            isAdmin: false,
          });
        }

        return;
      }

      try {
        const tokenResult = await user.getIdTokenResult(true);

        if (active) {
          setAdminState({
            adminLoading: false,
            isAdmin: tokenResult.claims.admin === true,
          });
        }
      } catch (error) {
        console.error("Failed to load administrator role:", error);

        if (active) {
          setAdminState({
            adminLoading: false,
            isAdmin: false,
          });
        }
      }
    }

    loadAdminClaim();

    return () => {
      active = false;
    };
  }, []);

  return adminState;
}
